export const ROULETTE_JOURNEY_KEY = 'rouletteJourney';
